// theme.js
import { createTheme } from '@mui/material/styles';

const muitheme = createTheme({
  palette: {
    // mode: 'dark',
  //   primary: {
  //     main: '#1976d2',
  //   },
  //   secondary: {
  //     main: '#ff4081',
  //   },
    // background: {
    //   default: '#121212',
    //   paper: '#1e1e1e',
    // },
  // },
  // typography: {
  //   fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  //   button: {
  //     textTransform: 'none',
  //   },
  },
  components: {
    // MuiButton: {
    //   styleOverrides: {
    //     root: {
    //       borderRadius: 8,
    //       padding: '8px 20px',
    //     },
    //   },
    // },
    MuiDialog: {
      styleOverrides: {
        paper: {
            boxShadow: '0 360px 101px 0 rgba(0, 0, 0, 0.00), 0 231px 92px 0 rgba(0, 0, 0, 0.02), 0 130px 78px 0 rgba(0, 0, 0, 0.08), 0 58px 58px 0 rgba(0, 0, 0, 0.13), 0 14px 32px 0 rgba(0, 0, 0, 0.15), 0 0 0 0 rgba(0, 0, 0, 0.15)',
            borderRadius: 32,
            backgroundColor: 'var(--white)',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
            backgroundColor: 'var(--white)',
            borderRadius: 32,
            boxShadow: "none",
        //     color: '#fff',
        // // borderRadius: 12,
        },
      },
    },
  },
});

export default muitheme;